import { useParams } from 'react-router'
import { DisplayPriceGettingParams } from '../../../../../../../../../../baseComponents/Displays/DisplayPrice'
import { AnimationReady, animationKeys } from '../../../../../../../../../../baseComponents/DoubleTable/types'
import { TableCheckboxLayoutLink } from '../../../../../../../../../../baseComponents/TwinTable/TableCheckboxLayout'
import { CustomRenderString, CustomRenderDate } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import locations from '../../../../../../../../../../utils/globals/locations'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { SellDeliveryNoteModelType, sellDeliveryNoteStatusInversed } from '@teinor/erp/types/company/order/sell/sellDeliveryNote'


type TableSellDeliveryNotePendingProps = AnimationReady  & {
}
interface SellDeliveryNoteExtended extends SellDeliveryNoteModelType {
    selected: boolean
}
const TableSellDeliveryNotePending: React.FC<TableSellDeliveryNotePendingProps> = ({ animationReady }) => {
    const { t } = useTwinTranslation()
    const { CustomerId } = useParams()
    const columns: ColumnTableSchema<SellDeliveryNoteExtended> = [
        {
            id: 'full_assigned_number',
            dataKey: 'full_assigned_number',
            label: t('nAssigned', 'Nº Asignado'),
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={(allRowData?.custom_name ? allRowData?.custom_name + ' - ' : '') + parameterValue} className={allRowData?.assigned_number ? '' : 'text-red-BA'} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('nAssigned', 'Nº Asignado') }
            },
            minWidth: 160,
        },
        {
            id: 'processed_date',
            dataKey: 'processed_date',
            label: t('createdDate', 'Fecha de creación'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue || allRowData.createdAt} className={parameterValue ? '' : 'text-red-BA'} />,
            sortable: true,
            minWidth: 165
        },
        {
            id: 'total_without_vat',
            dataKey: 'total_without_vat',
            label: t('totalWithoutVatS', 'B. imponible'),
            simpleLabel: t('totalWithoutVat', 'Base imponible'),
            sortable: true,
            minWidth: 130,
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={false} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'total_total',
            dataKey: 'total_total',
            label: t('total', 'Total'),
            sortable: true,
            minWidth: 100,
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={allRowData.with_vat} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'CustomerProjectId',
            dataKey: 'CustomerProjectId',
            label: t('project', 'Proyecto'),
            hideColumnByDefault: true,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.CustomerProject?.name || ''} />
        },
        {
            id: 'CreateEmployeeId',
            dataKey: 'CreateEmployeeId',
            label: t('employee', 'Empleado'),
            searchKey: 'CreateEmployee.fullname_short',
            customRender: (_parameterValue, allRowData) => {
                const employeeName = allRowData?.CreateEmployee ? allRowData?.CreateEmployee?.fullname_short : allRowData?.ProcessEmployee?.fullname_short
                return <CustomRenderString value={employeeName || ''} />
            },
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('employee', 'Empleado') }
            },
            hideColumnByDefault: true,
        },
        {
            id: 'RepresentativeEmployeeId',
            dataKey: 'RepresentativeEmployeeId',
            label: t('representative', 'Representante'),
            searchKey: 'RepresentativeEmployee.fullname_short',
            customRender: (_parameterValue, allRowData) => {
                const employeeName = allRowData?.RepresentativeEmployee?.fullname_short
                return <CustomRenderString value={employeeName || ''} />
            },
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('representative', 'Representante') }
            },
            hideColumnByDefault: true,
        },
    ]
    if (animationReady !== animationKeys['loaded']) {
        return null
    }
    return (
        <TableCheckboxLayoutLink name='generateDeliveryNoteCheck' extraWhereParams={{ 'SellDeliveryNote.CustomerId': CustomerId, 'status': { '$or': [sellDeliveryNoteStatusInversed['pendingUnits'], sellDeliveryNoteStatusInversed['waitingResponse']] } }} translations={{
            buttonText: t('generateDeliveryNoteRefund', 'Generar devolución de albarán')
        }} columns={columns} getDataFrom='/api/app/order/sell/sellDeliveryNote/getAllSellDeliveryNotesComplete' baseLink={locations.sellDeliveryNoteRefundMulti+'/generateFromDeliveryNote/'} />
    )
}

export default TableSellDeliveryNotePending
